import {Pipe, PipeTransform} from '@angular/core';
import {ColumnType, TableService} from 'app/shared/service/table.service';

/**
 * Renvoie le type d'input à associer en fonction du type de colonne.
 */
@Pipe({name: 'columnInputType'})
export class ColumnInputTypePipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(columnType: ColumnType): string {
        return this.tableService.getInputTypeFromColumnType(columnType);
    }
}
